import type { DialogueOrderMessage } from 'components/Dialogue/types';
import { UIMessages } from '../../useChatView';
import LazyOrderMessage from '../LazyOrderMessage';
import QuoteMessage from '../QuoteMessage';
import { LocalMessage } from 'hooks/business/conversation';
import { MessageStatusDecorate } from '../MessageStatusDecorate';
import { useChatContext } from '../../contexts/ChatContext';
import { MessageExtend } from '../MessageExtend';
import { memo } from 'react';

interface OrderMsgProps {
  msg: UIMessages;
  raw: LocalMessage;
  conversation: Conversation.Conversation;
}

export const OrderMsg = memo((props: OrderMsgProps) => {
  const { msg, raw, conversation } = props;

  const { clickQuote, dialogRef } = useChatContext();
  const { topBarInfo } = conversation;
  const { failCause } = raw;
  const dataScource = (msg as DialogueOrderMessage).content;

  return (
    <LazyOrderMessage
      rawMsg={msg.raw}
      buyerId={conversation?.buyerId ?? ''}
      storeId={conversation?.storeId ?? ''}
      tunnelAccountId={conversation?.tunnelAccountId || '0'}
      externalTradeId={`${dataScource.id}`}
      externalStoreId={msg.raw.orderContent?.externalStoreId || ''}
      channel={`${conversation?.channel}`}
      quote={
        <QuoteMessage message={raw} storeName={topBarInfo?.storeName} onQuoteClick={clickQuote} />
      }
      lazyScrollContainer={dialogRef?.dom}
    >
      {(component, status) => {
        if (status === 'success') {
          const result = (
            <MessageStatusDecorate
              message={raw}
              status={msg?.status}
              content={component}
              failCause={failCause}
              dialogRef={dialogRef}
            />
          );
          return <MessageExtend raw={raw} msg={msg} conversation={conversation} content={result} />;
        }
        // 如没有加载成功，不展示于界面上
        return null;
      }}
    </LazyOrderMessage>
  );
});
